import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Currency } from '../../models/currency';
import { ConfigService } from '@core/services/config.service';

@Injectable()
export class CurrencyApiService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  private get baseUrl(): string {
    const config = this.configService.getCurrent();
    return `${config.services.booking}/api/currency`;
  }

  public getAllCurrecy(search: string = '', pageOffset: number = 0, pageSize: number = 100): Observable<Currency[]> {
    const params = new HttpParams()
      .append('search', search)
      .append('pageOffset', pageOffset.toString())
      .append('pageSize', pageSize.toString());
    return this.http.get<Currency[]>(this.baseUrl, { params: params });
  }
}
